import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import OutsourcingPriceUpdateModal from "../../../../modal/PC/quality/OutsourcingPriceUpdateModal";
import AssignmentIcon from '@mui/icons-material/Assignment';
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import Checkbox from "../../../../common/Checkbox";
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const OutsourcingPrice = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [gridWidth, setGridWidth] = useState('520px');
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectID, setSelectID] = useState('');
    const [keyword, setKeyword] = useState({
        yyyy: Moment().format("YYYY")
    });
    const [yyyyOption, setYYYYOption] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        yyyy_mm: true,
        outsourcing_price: false,
        outsourcing_target_price: false,
        outsourcing_display_price: true,
        outsourcing_target_display_price: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.yyyy])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    const handleInitSelect = () => {
        
        let yearOptions = [];
        for (let y = 2025; y <= 2099; y++) {
            yearOptions.push({ value: String(y), label: String(y) });
        }
        setYYYYOption(yearOptions);
        setColumns([
            {
                field: 'updated',
                headerName: '작성',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color={ MenuUpdateYN === "Y" ? "primary" : "grey"} />} onClick={() => {UpdateClick(params)}} label="Edit" disabled={ MenuUpdateYN === "Y"? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'yyyy_mm', headerName: '년월', width: 100, headerAlign: 'center', align:'center'},
            { field: 'outsourcing_price', headerName: '외주비용', width: 140, headerAlign: 'center', align:'right' },
            { field: 'outsourcing_target_price', headerName: '외주목표비용', width: 150, headerAlign: 'center', align:'right' },
            { field: 'outsourcing_display_price', headerName: '외주비용', width: 140, headerAlign: 'center', align:'right' },
            { field: 'outsourcing_target_display_price', headerName: '외주목표비용', width: 150, headerAlign: 'center', align:'right' }
        ]);
    };

    const UpdateClick = (object) => {
        setSelectID(object.row.yyyy_mm);
        setUpdateModalOpen(true);
        setModalTitle('외주비용 작성');
    };

    const handleInit = () => {
        setKeyword({
            yyyy: Moment().format("YYYY")
        });
    };

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/OutsourcingPrice/List',
            {
            params : {
                yyyy : keyword.yyyy
            }
        },
        { withCredentials: true }
        )
        .then((response) => { 
            const array = (response.data).map((item, index) => ({
                id: item.yyyy_mm,
                yyyy_mm: item.yyyy_mm,
                outsourcing_price: item.outsourcing_price,
                outsourcing_target_price: item.outsourcing_target_price,
                outsourcing_display_price: String(item.outsourcing_price).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                outsourcing_target_display_price: String(item.outsourcing_target_price).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }));
            setRows(array);
            setOriginRows(array);

            setGraphData([]);
            let graph_array = []
            for(let i = 0; i < array.length; i++) {
                let row = {name: array[i].yyyy_mm, '비용': Number(array[i].outsourcing_price), '목표': Number(array[i].outsourcing_target_price)}
                graph_array = graph_array.concat(row)
            }
            
            setGraphData(graph_array);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const onSelectChange = (type, value) => {
        var nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '140px', boxShadow: 'none' } }>
            <div className="menu-action" style={ { height: '55px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '80px', paddingTop: '7px', fontWeight: 'bold' } }>
                            년도
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="년도" onChange={(e) => onSelectChange('yyyy',e.value)} value={yyyyOption.filter(function (option) { return option.value === keyword.yyyy;  })} options={yyyyOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={ { width: '100%' } }>
            <div className="grid" style={ { top: '142px', float: 'left', width: gridWidth } }>
                <div style={{ float: 'left' }}>
                    <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 242px)', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
            <div className="grid" style={ { top: '188px', float: 'right', width: 'calc(100% - '+gridWidth+')', position: 'relative', overflowY: 'hidden' } }>
                
                <div style={{ float: 'right', width: '100%', paddingRight:'50px'}}>
                    <div style={{ width: '100%', height: 'calc(100vh - 350px)' }}>
                        <ResponsiveContainer>
                            <ComposedChart width={'calc(100% - '+gridWidth+')'} height={'calc(100vh - 350px)'} data={graphData} margin={{ top: 5, right: 5, bottom: 0, left: 50 }}>
                                <CartesianGrid stroke="#f5f5f5" />
                                <XAxis dataKey="name" />
                                <YAxis tickFormatter={tick => { return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }} />
                                <Tooltip formatter={(okay) => new Intl.NumberFormat('ko').format(okay)} />
                                <Bar dataKey={"비용"} barSize={10} fill="#8884d8" />
                                <Line dataKey={"목표"} stroke="#ff3636" fillOpacity={5} />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>
                </div>
                {isUpdateModalOpen && MenuUpdateYN === 'Y' && (
                    <OutsourcingPriceUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectID}
                        originRows={originRows.filter(row => String(row.yyyy_mm) === String(selectID))}
                        handleView={handleView}
                    />
                )}
            </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default OutsourcingPrice;